import styled from "styled-components";

export const Container = styled.div`
  background: #f7f7f7 0% 0% no-repeat padding-box;
  width: 100%;
  display: flex;
  padding-top: 50px;
  padding-bottom: 50px;
`;

export const Wrapper = styled.div`
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  background: #00c1d4 0% 0% no-repeat padding-box;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5%;
`;

export const MainTitle = styled.span`
  color: #003865;
  text-align: center;
  font-size: 48px;
  @media only screen and (max-width: 680px) {
    font-size: 35px;
    margin-top: 10%;
    margin-bottom: 10%;
  }
`;

export const Subtitle = styled.span`
  color: #003865;
  font: normal normal bold 20px/30px BiNeo;
  text-align: center;
  margin-top: 17px;
  @media only screen and (max-width: 680px) {
    font-size: 25px;
  }
`;

export const Phrase = styled.span`
  color: white;
  font-size: 18px;
  text-align: center;
  margin-top: 58px;
`;

export const AssuranceOptionsContainer = styled.div`
  display: flex;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 580px) {
    flex-direction: column;
  }
`;

export const StyledTextInput = styled.input`
  background-color: #fff;
  border-width: 0px;
  width: 100%;
  border-color: #cbcbcb;
  border-radius: 8px;
  height: 60px;
  margin-right: 2%;
  padding-left: 10px;
  @media only screen and (min-width: 680px) {
    flex: 4;
  }
`;

export const StyledBlueButton = styled.button`
  color: white;
  background: #003865 0% 0% no-repeat padding-box;
  border: 1px solid #003865;
  border-radius: 10px;
  height: 60px;
  margin-top: 1rem;
  &:hover {
    cursor: pointer;
    background-color: #ffb81c;
    border: 1px solid #ffb81c;
    color: #003865;
  }
  @media only screen and (min-width: 680px) {
    flex: 1;
    margin-top: 0;
  }
`;

export const FormWrapper = styled.div`
  background: #00c1d4 0% 0% no-repeat padding-box;
  border-radius: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5% 0 5% 0;
  @media only screen and (max-width: 680px) {
    padding: 0;
  }
`;

export const ProcessWrapper = styled.div`
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  width: 75%;
  min-height: 50vh;
  @media only screen and (max-width: 680px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 15px;
  background-color: #ebebeb;
  margin-top: 5%;
  position: relative;
`;

export const ProgressBarIndicator = styled.div`
  position: absolute;
  height: 15px;
  background-color: #00c1d4;
  width: ${(props) => props.progressWidth}%;
  border-radius: 0 10px 10px 0;
  max-width: 100%;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.column ? "column" : "row")};
  gap: 3%;
  align-items: ${(props) => (props.center ? "center" : "initial")};
  justify-content: ${(props) => (props.centerV ? "center" : "initial")};
  flex: ${(props) => props.flex || "initial"};
  padding: 4px;
  @media only screen and (max-width: 680px) {
    flex-direction: column;
  }
`;

export const EmailContainer = styled.div`
  width: 72%;
  padding-right: 2rem;

  @media only screen and (max-width: 768px) {
    width: 97%;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;
